export default __webpack_public_path__ + "static/media/photo--sm--16.41f7ebad.jpg";